import { Component, OnInit } from '@angular/core';
import { User } from '../user/user';
import { UserService } from '../_services';
import { ActivatedRoute } from '@angular/router';
import { Maintenance } from './maintenance';
import { MaintenanceService } from './maintenanceService';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import htmlToPDFmake from 'html-to-pdfmake';
import { Logo } from '../ticketview/logo';
import { DatePipe } from '@angular/common';
import { M } from '@angular/cdk/keycodes';


@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.less', '../app.component.less']
})
export class MaintenanceComponent implements OnInit {

  public Editor = ClassicEditor;
  public model = {
    name: 'John',
    surname: 'Doe',
    description: '<p>A <b>really</b> nice fellow.</p>'
  };
  public visitdetails = "";
  public commentconfig = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList',
        '|',
        'outdent',
        'indent',
        '|',
        'blockQuote',
        'insertTable',
        'undo',
        'redo',
        'alignment' // <--- ADDED 
      ]
    },
    table: {
      contentToolbar: [
        'tableColumn',
        'tableRow',
        'mergeTableCells',
        'tableCellProperties', // <--- ADDED 
        'tableProperties' // <--- ADDED 
      ]
    },
    // This value must be kept in sync with the language defined in webpack.config.js.
    language: 'en'
  };
  pdfmake = pdfMake;
  public visitDetailsIsDisabled = true;
  private _currentUser: User;
  public maintenance = new Maintenance;
  public cnt = 0;


  constructor(private userservice: UserService,
    private route: ActivatedRoute,
    private maintenanceservice: MaintenanceService,
    private datePipe: DatePipe) { }



  //---------------------------------------------------------------------------
  // ON INIT FUNCTION 
  //---------------------------------------------------------------------------

  ngOnInit() {
    this._currentUser = this.userservice.getCurrentUserFromCookie();
    const id = +this.route.snapshot.paramMap.get('id');
    this.maintenanceservice.getMaintenacneGql(id).subscribe(response => {
      this.maintenance = response;
      this.cnt = response.counter;
    }
    );
  }

  //--------------------------------------------------------------------------
  //   TOGGLE EDITABLE FIELDS ON/OFF
  //--------------------------------------------------------------------------  

  endisDetail() {
    this.visitDetailsIsDisabled = !this.visitDetailsIsDisabled;
  }

  //--------------------------------------------------------------------------
  //   SAVE CHANGES - COUNTER & VISIT DETAILS
  //--------------------------------------------------------------------------  

  save() {
    this.endisDetail();
    this.maintenanceservice.updateMaintenance(this.maintenance.visitdetails, this.maintenance.id, this.cnt).subscribe(resp => {
      this.ngOnInit();
    });

    window.alert("Changes Saved!");
  }

  //--------------------------------------------------------------------------
  //   EXPORT TO PDF FUNCTION
  //--------------------------------------------------------------------------  

  onExportClick() {
    this.save();
    var now = new Date();
    var datenow;
    datenow = this.datePipe.transform(now, "dd-MM-yyyy");
    var lg: Logo;
    lg = new Logo;
    var strlg: string;
    var clname: string;
    var wdth: number;
    if (this._currentUser.client.id == 7) {
      strlg = lg.infotech();
      clname = this.maintenance.machine.location.addr1;
      wdth = 100;
    }
    else {
      strlg = lg.kgroup();
      clname = this.maintenance.client.name;
      wdth = 150;
    }
    var pdfcontent = htmlToPDFmake(this.maintenance.visitdetails);

    //--------------------------------------------------------------
    // TABLES FORMATTING FOR CUSTOMER DETAILS
    //--------------------------------------------------------------

    const customerDetailsData = [[{ style: 'mycell', text: 'Customer' }, { style: 'bigger', text: clname + '\n' },
    { style: 'mycell', text: 'PMR No: ' }, { style: 'bigger', text: '#: ' + this.maintenance.id + '\n' }],
    [{ style: 'mycell', text: 'Contact' }, this.maintenance.machine.location.contact_name, { style: 'mycell', text: 'Add1' }, this.maintenance.machine.location.addr1],
    [{ style: 'mycell', text: 'Phone' }, this.maintenance.machine.location.phone_number, { style: 'mycell', text: 'City' }, this.maintenance.machine.location.City],
    [{ style: 'mycell', text: 'Email' }, this.maintenance.machine.location.email, { style: 'mycell', text: 'Country' }, this.maintenance.machine.location.Country],
    ];

    //--------------------------------------------------------------
    // TABLES FORMATTING FOR MAINTENANCE DETAILS
    //--------------------------------------------------------------

    const maintenanceInfoData = [[{ style: 'mycell', text: 'Date of Visit' }, { style: 'bigger', text: this.maintenance.dateofvisit + '\n' },
    { style: 'mycell', text: 'Machine Counter' },
    { style: 'bigger', text: this.maintenance.counter + '\n' }],
    ];

    //--------------------------------------------------------------
    // TABLES FORMATTING FOR MACHINE DETAILS
    //--------------------------------------------------------------
    const machineInfoData = [
      [{ style: 'mycell', text: 'Asset' }, { style: 'bigger', text: this.maintenance.machine.shortname + '\n' },
      { style: 'mycell', text: 'Serial No' }, { style: 'bigger', text: this.maintenance.machine.serialnumber + '\n' }],
      [{ style: 'mycell', text: 'State' }, this.maintenance.machine.state.statevalue, '', '']];

    //--------------------------------------------------------------
    // TABLES FORMATTING FOR TICKET DETAILS & RESOLUTION
    //--------------------------------------------------------------
    const pdfcontTable = [[{ style: 'mycell', text: 'Details' }],
    [pdfcontent]
    ];


    //--------------------------------------------------------------
    // TABLES FORMATTING FOR SIGNATURE FOOTER
    //--------------------------------------------------------------
    const sigTable = [
      [{ style: 'mycell', text: 'Technician Name' }, this.maintenance.user.firstname + ' ' + this.maintenance.user.lastname, { style: 'mycell', text: 'Customer Name' }, this.maintenance.machine.location.contact_name],
      [{ style: 'mycell', text: 'Signature\n' }, '', { style: 'mycell', text: 'Signature\n' }, '']];


    //--------------------------------------------------------------
    // ARRAY FOR BUILDING PDF DOCUMENT  
    //--------------------------------------------------------------
    const documentHeader = { // PDF DOCUMENT HEADER AS ARRAY
      content:
        [
          {
            image: strlg,
            width: wdth
          },
          { style: 'header', alignment: 'center', text: 'Maintenance Report \n\n' },
          ,
          { style: 'bigger', text: 'Customer Details' },
          { table: { widths: [75, 250, 65, 85], body: customerDetailsData } },

          { style: 'bigger', text: '\nVisit Information' },
          { table: { widths: [75, 250, 65, 85], body: maintenanceInfoData } },
          { style: 'bigger', text: '\nAsset Info' },
          { table: { widths: [75, 250, 65, 85], body: machineInfoData } },
          { text: '\n' },
          { table: { widths: [500], body: pdfcontTable } },
          { text: '\n' },
          { text: '\n\n\n' },
        ]
    };

    const documentFooter = { // PDF DOCUMENT FOORER AS ARRAY      
      content: [
        {
          absolutePosition: { x: 40, y: 750 },
          table: { widths: [100, 135, 100, 135], heights: [20, 40], body: sigTable }
        },
      ],
    };

    // DOCUMENT DEFAULT CONFIGURATION 
    const def = {defaultStyle: {fontSize: 11,columnGap: 0,  } };
    // DOCUMENT STYLES ADDITION 
    const stl = {styles:{ header: {fontSize: 14, bold: true,  }, mycell: {fillColor: '#ECECEC', width: 700 }, bigger: { fontSize: 11, bold: true } } };

    //----------------------------------------------------------
    // DOCUMENT CREATION AND ADDITION OF STYLES AND CONTENT
    //----------------------------------------------------------

    var pubz = { content: [], styles: {}, defaultStyle: {} };
    pubz.styles = stl.styles;
    pubz.defaultStyle = def.defaultStyle;
    pubz.content.push(documentHeader.content);
    pubz.content.push(documentFooter.content);
    this.pdfmake.createPdf(pubz).open();

  }

}
